export class ApiError extends Error {
  constructor(
    public status: number,
    public body: unknown,
  ) {
    super(`API error ${status}`)
    this.name = "ApiError"
  }
}

// Backend errors are a plain string or a ProblemDetails object.
export function apiErrorMessage(err: unknown): string | null {
  const body = err instanceof ApiError ? err.body : err
  if (typeof body === "string") return body.trim() || null
  if (body && typeof body === "object") {
    const record = body as Record<string, unknown>
    for (const key of ["detail", "title", "message"]) {
      const value = record[key]
      if (typeof value === "string" && value.trim()) return value.trim()
    }
  }
  return null
}
